import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const WebhookTemplateList = lazy(() =>
  import("@scenes/MessageComposition/Webhook/WebhookTemplates/WebhookTemplateLibrary/WebhookTemplateList").then(
    (module) => ({
      default: module.WebhookTemplateList,
    })
  )
);

export const webhookTemplatesNRO: NavigationRoutingObject = {
  Component: WebhookTemplateList,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "templates",
  heading: (t: I18nT<"dashboard-navigation">) => t("webhook-templates", "Webhook Templates"),
  pageNameForTracking: () => "Webhook Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("webhook-templates-description-nav", "Create and manage webhook templates"),
  icon: "nav-system-webhook-dashed",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    // Match develop: show in side nav when webhook is on. No-permission view is rendered inside
    // WebhookTemplateDataTable (same pattern as emailTemplatesNRO / EmailTemplateList).
    return featureOn("webhook");
  },
  shouldShowTertiaryNavigationCallback: ({ hasPermission }) => {
    return hasPermission("appGroupOrAnyTeamInAppGroup", { permission: "viewWebhookTemplates" });
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      // "webhooks" (plural) does not match the heading "Webhook Templates"
      keywords: [t("webhook-templates-alt-keyword-1", "Webhooks templates")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
